import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { getCompanyDetails } from "../../../api/endpoints/company";


const CompanyFormModal = ({ show, onClose, onSave, compId }) => {
  const [form, setForm] = useState({
    comp_id: "",
    comp_name: "",
    comp_person: "",
    comp_gst: "",
		password: "",
    email: "",
    mobile: "",
    comp_address: "",
    comp_website : "",
    comp_billing_mail: "",
    comp_status: "",
  });

  const [validated, setValidated] = useState(false);
  const isEdit = !! compId;

  useEffect(() => {
    const fetchData = async () => {
      if (isEdit && show) {
        try {
          const response = await getCompanyDetails(compId);
          if (response.status === 200) {
            const data = response.data.data;
            setForm({
              comp_id: data.comp_id || "",
              comp_name: data.company_name || "",
							comp_gst : data.company_gst || "",
              comp_person: data.contact_person || "",
              email_id: data.email_id || "",
              mobile: data.comp_mobile || "",
              comp_address: data.address || "",
              comp_website: data.website || "",
              comp_billing_mail: data.billing_email || "",
              comp_status: data.comp_status ? "Active": "Block" || "Block",
            });
          }
        } catch (err) {
          console.error("Error fetching company:", err);
        }
      } else {
        setForm({
          comp_id: "",
					comp_name: "",
					comp_person: "",
					comp_gst: "",
					password: "",
					email: "",
					mobile: "",
					comp_address: "",
					comp_website : "",
					comp_billing_mail: "",
					comp_status: "",
        });
      }
    };
    fetchData();
  }, [compId, show]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formElement = e.currentTarget;

    if (formElement.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    onSave(form);
    onClose();
  };

  return (
    <div className={`modal fade ${show ? "show d-block" : ""}`} tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header bg-light p-3">
            <h5 className="modal-title">{isEdit ? "Edit Company" : "Add Company"}</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
					<form onSubmit={handleSubmit} 
            className={`tablelist-form needs-validation ${validated ? "was-validated" : ""}`}
            noValidate
            autoComplete="off">
						<div className="modal-body">
							<div className="row">
									{isEdit && (
										<div className="col-12">
											<div className="mb-3">
												<label className="form-label">Company ID</label>
												<input type="text" className="form-control cursor-default bg-gray-100" value={form.comp_id} readOnly />
											</div>
										</div>
									)}
									<div className="col-12">
											<div className="mb-3">
													<label for="compNameinput" className="form-label">Company Name</label>
													<input type="text" name="comp_name" className="form-control" placeholder="Enter company name" id="compNameinput" value={form.comp_name} onChange={handleChange} required />
													<div className="invalid-feedback">Please enter company name.</div>
											</div>
									</div>
									<div className="col-6">
											<div className="mb-3">
													<label for="personNameinput" className="form-label">Contact Person Name</label>
													<input type="text" name="comp_person" className="form-control" placeholder="Enter company person name" id="personNameinput" value={form.comp_person} onChange={handleChange} required/>
													<div className="invalid-feedback">Please enter company contact person name.</div>
											</div>
									</div>
									<div className="col-6">
											<div className="mb-3">
													<label for="compnayGSTinput" className="form-label">Company GST Number</label>
													<input type="text" name="comp_gst" className="form-control" placeholder="Enter company GST no." id="compnayGSTinput" value={form.comp_gst} onChange={handleChange}/>
											</div>
									</div>
									
									<div className="col-6">
											<div className="mb-3">
													<label for="phonenumberInput" className="form-label">Mobile Number</label>
													<input type="tel" name="mobile" className="form-control" placeholder="99999999999" id="phonenumberInput" value={form.mobile} onChange={handleChange} required/>
													<div className="invalid-feedback">Please enter mobile number.</div>
											</div>
									</div>
									{isEdit && (
											<div className="col-6">
													<div className="mb-3">
															<label for="emailidInput" className="form-label">Email Address / Username</label>
															<input type="email" className="form-control" placeholder="example@gamil.com" id="emailidInput" value={form.email_id}  readonly/>
													</div>
											</div>
										)}
									{!isEdit && (
										<>
											<div className="col-6">
													<div className="mb-3">
															<label for="emailidInput" className="form-label">Email Address / Username</label>
															<input type="email" name="email" className="form-control" placeholder="example@gamil.com" id="emailidInput" onChange={handleChange} required/>
															<div className="invalid-feedback">Please enter mobile number.</div>
													</div>
											</div>
											<div className="col-12">
													<div className="mb-3">
															<label for="passwordInput" className="form-label">Company Login Password</label>
															<input type="password" name="password" className="form-control" placeholder="Enter Password" minLength={8} maxLength={16} id="passwordInput" onChange={handleChange} required/>
															<div className="invalid-feedback">Please enter password.</div>
													</div>
											</div>
										</>
									)}
									<div className="col-12">
											<div className="mb-3">
													<label for="address1ControlTextarea" className="form-label">Address</label>
													<input type="text" name="comp_address" className="form-control" placeholder="Company Address" id="address1ControlTextarea" value={form.comp_address} onChange={handleChange} required/>
													<div className="invalid-feedback">Please enter address.</div>
											</div>
									</div>
									<div className="col-6">
											<div className="mb-3">
													<label for="websiteNameInput" className="form-label">Website</label> 
													<input type="text" name="comp_website" className="form-control" placeholder="Enter company website" id="websiteNameInput" value={form.comp_website} onChange={handleChange}/>
											</div>
									</div>
									<div className="col-6">
											<div className="mb-3">
													<label for="billingMailInput" className="form-label">Billing Email Id</label>
													<input type="text" name="comp_billing_mail" className="form-control" placeholder="Enter company billing mail id" id="billingMailInput" value={form.comp_billing_mail} onChange={handleChange} required/>
													<div className="invalid-feedback">Please enter billing mail id.</div>
											</div>
									</div>
									<div className="col-12">
											<div className="mb-3">
													<label for="ForminputState" className="form-label">Status</label>
													<select id="ForminputState" name="comp_status" className="form-select" onChange={handleChange} value={form.comp_status}  required>
															<option value="">Select Status</option>
															<option value="Active">Active</option>
															<option value="Block">Block</option>
													</select>
													<div className="invalid-feedback">Please select status.</div>
											</div>
									</div>
									<div className="col-lg-12">
											<div className="text-end">
													<button type="button" className="btn btn-light me-2" onClick={onClose}>
														Close
													</button>
													<button type="submit" className="btn btn-success">Submit</button>
											</div>
									</div>
							</div>
						</div>
				</form>
        </div>
      </div>
    </div>
  );
};

CompanyFormModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  adminId: PropTypes.string,
};

export default CompanyFormModal;